import React, { Component } from 'react'
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs'
import MainLayout from '../CommonControlls/MainLayout'
import Topmenu from '../CommonControlls/Topmenubar'
import { connect } from 'react-redux'
import Table from '../CommonControlls/TableRendrer'
import { Link } from 'react-router-dom'
import {
  SelectDistrictsList,
  SelectAllProvince,
} from '../OfflineDb/IndexDbTranscSP'
import AlertModal from '../CommonControlls/AlertModal'
import { SyncConfig } from '../OfflineDb/ConfigDataSync'
import DropDown from '../CommonControlls/DropdownRendrer'
import jsPDF from 'jspdf'

const mapStateToProps = (store) => {
  return store
}

const mapDispatchToProps = (dispatch) => {
  return {
    ShowAlert: (Settings) => {
      dispatch({ type: 'UpdateAlert', payload: Settings })
    },
    ShowLoader: (Isloading) => {
      dispatch({ type: 'UpdateLoader', payload: Isloading })
    },
  }
}

class District_List extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // Table
      data: [],
      page: 1,
      sizePerPage: 200,
      TotalRecord: 0,
      loading: false,

      permissions: [],

      sortField: 'id',
      idsortOrder: 'desc',
      provinceNamesortOrder: '',
      namesortOrder: '',

      alertModalData: {
        title: '',
        message: '',
        First_Callback: () => {},
        Second_Callback: () => {},
        type: 1,
      },

      ProvinceLoader: false,
      Provincelist: [],
      ProvinceId: 0,

      exportLoading: false,

      SrList: [],

      FilteredData: [],
      FilteredSrs: [],
      SrId: [],
    }
  }

  HandleAutoSuggestValChange = (fieldId, value) => {
    if (fieldId === 'ProvinceId') {
      const tempArr = this.state.SrList
      const filteredSrs = tempArr.filter((item) => item.provinceid === value)
      this.setState({
        FilteredSrs: filteredSrs,
        [fieldId]: value,
      })
    }
    this.setState({ [fieldId]: value })
  }

  render() {
    const CellMenu = (cell, row) => {
      return (
        <div>
          {this.state.permissions.includes('district-update') && (
            <Link to={'/District_Edit/' + row.id}>
              <button
                data-toggle="tooltip"
                title="Edit"
                class="btn TableRow_btn"
              >
                <i
                  class="fa fa-pencil-square-o text-primary"
                  aria-hidden="true"
                ></i>
              </button>
            </Link>
          )}
          {this.state.permissions.includes('district-delete') && (
           
           <button
              onClick={() => this.onDelete(row.id)}
              data-toggle="tooltip"
              title="Delete"
              class="btn TableRow_btn"
            >
              <i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
            </button>
          )}
        </div>
      )
    }

    const columns = [
      {
        dataField: 'provinceName',
        text: 'Province Name',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { minWidth: 150 }
        },
      },
      {
        dataField: 'short_name',
        text: 'SR. Name',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { minWidth: 120 }
        },
      },
      {
        dataField: 'name',
        text: 'District Name',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { minWidth: 150 }
        },
      },
      {
        dataField: 'lat',
        text: 'Latitude',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { minWidth: 120 }
        },
      },
      {
        dataField: 'lng',
        text: 'Longitude',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { minWidth: 120 }
        },
      },
      {
        dataField: '',
        text: 'Actions',
        headerStyle: (colum, colIndex) => {
          return { minWidth: 120 }
        },
        formatter: (cell, row) => {
          return CellMenu(cell, row)
        },
        csvExport: false,
      },
    ]

    return (
      <div>
        <AlertModal {...this.state.alertModalData} />
        <MainLayout />
        <div id="right-panel" class="right-panel">
          <Topmenu
            PageTitle="Districts"
            isShowAddBtn={this.state.permissions.includes('district-add')}
            AddBtnLabel="Add District"
            AddBtnLink="/District_Add"
          />
          <div class="content">
            {/* <div class="PageHeader_Container">
                            <h2 class="Pageheading">Districts</h2>
                            <div class="PageMenu_Container"><Link to="District_Add"><button type="submit" id="Form_SaveBtn" class="btn btn_style2">Add District</button></Link></div>
                        </div> */}

            <div class="card">
              <div class="card-body">
                <div class="Table_Search row">
                  <div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="">Province</label>
                    <DropDown
                      multi={false}
                      dropdownRenderer={false}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="ProvinceId"
                      options={this.state.Provincelist}
                      val={this.state.ProvinceId}
                      addPlaceholder=""
                      disabled={false}
                      loading={this.state.ProvinceLoader}
                      searchBy="name"
                      labelField="name"
                      valueField="id"
                      contentRenderer={false}
                      placeholder="Select"
                    />
                  </div>

                  <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="">Sub Recipient</label>
                    <DropDown
                      multi={true}
                      dropdownRenderer={true}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="SrId"
                      options={this.state.FilteredSrs}
                      val={this.state.SrId}
                      addPlaceholder=""
                      disabled={false}
                      loading={false}
                      searchBy="name"
                      labelField="name"
                      valueField="id"
                      contentRenderer={true}
                      placeholder="Select"
                    />
                  </div>

                  <div class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="">District Name</label>
                    <input
                      autocomplete="off"
                      type="text"
                      onChange={this.handleInputChange}
                      class="form-control Search_InputField"
                      id="name"
                      placeholder="Enter district name"
                    />
                  </div>

                  <div class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <button
                      onClick={() => {
                        this.FilterTable()
                      }}
                      id="FormSearchBtn"
                      class="btn SearchTable_Btn"
                      style={{ position: 'relative', marginTop: 36 }}
                    >
                      Search
                    </button>
                  </div>
                </div>

                {/*<div class="TableTop_Buttons">*/}
                {/*    <span onClick={this.ExportPdf} class="TableExport_button">*/}
                {/*        <i class="fa fa-download" aria-hidden="true"></i> Export Pdf*/}
                {/*    </span>*/}
                {/*</div>*/}

                <Table
                  keyField="id"
                  data={this.state.FilteredData}
                  page={this.state.page}
                  exportPdf={this.ExportPdf}
                  sizePerPage={this.state.sizePerPage}
                  totalSize={this.state.TotalRecord}
                  changeSizePerPage={(size) => {
                    setTimeout(() => {
                      this.setState({
                        exportLoading: true,
                      })
                      this.ExportData(size)
                    }, 100)
                  }}
                  exportAllowed={this.state.permissions.includes(
                    'district-export',
                  )}
                  onTableChange={this.handleTableChange}
                  isPagination={true}
                  columns={columns}
                  pdfExportLoading={this.state.exportLoading}
                  loading={this.state.loading}
                  RefreshTable={this.PopulateTable}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  handleInputChange = (event) => {
    const { value } = event.target

    const tempData = this.state.data
    const filtered = tempData.filter((item) => {
      return item.name.toLowerCase().includes(value.toLowerCase())
    })
    this.setState({
      FilteredData: filtered,
    })
  }

  FilterTable = () => {
    const tempDistricts = this.state.data
    const tempSrs = this.state.SrId.map((el) => el.id)

    const filtered = tempDistricts.filter(
      (item) =>
        item.provinceId === this.state.ProvinceId &&
        tempSrs.includes(item.subrecipientid),
    )
    this.setState({
      FilteredData: filtered,
    })
  }

  ExportPdf = () => {
    const doc = new jsPDF()
    this.setState({
      exportLoading: true,
    })

    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_District,
      {
        pageSize: this.state.TotalRecord,
        pageNumber: 1,
      },
      (resp) => {
        $('#FormSearchBtn').prop('disabled', false)
        if (resp.data.length > 0) {
          // Map
          var ProcessedProvince = Common.ProcessDataInArray(
            this.state.Provincelist,
            'id',
          )
          for (var i in resp.data) {
            resp.data[i].provinceName =
              resp.data[i].provinceId == null
                ? ''
                : ProcessedProvince[resp.data[i].provinceId].name
          }
          doc.autoTable({
            theme: 'grid',
            body: [...resp.data],
            columns: [
              { header: 'id', dataKey: 'id' },
              { header: 'Name', dataKey: 'name' },
              { header: 'Province', dataKey: 'provinceName' },
              { header: 'SR Name', dataKey: 'short_name' },
              { header: 'Latitude', dataKey: 'lat' },
              { header: 'Longitude', dataKey: 'lng' },
            ],
          })

          doc.save('districts.pdf')
          this.setState({
            exportLoading: false,
          })
        }
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }

  componentWillMount() {
    if (this.props.UserAuthentication.AuthToken === '') {
      this.props.history.push('/Login')
    }
  }

  componentDidMount() {
    Common.AddClassToMenueLink(
      'MenuLink_Districts',
      true,
      'MenuParentLink_Geography',
    )
    // Common.AddClassToMenueLink("MenuLink_Districts")

    this.SelectProvinces(() => {
      this.PopulateTable()
    })

    $('.Search_InputField').on('keypress', (e) => {
      if (e.which === 13) {
        this.PopulateTable()
      }
    })

    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectALl_SubRecipient,
      {},
      (resp) => {
        if (resp.status) {
          this.setState({
            SrList: resp.data.map((d) => ({
              id: d.id,
              name: d.short_name,
              ...d,
            })),
          })
        }
      },
    )

    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.SelectAll_RolesPermissions,
      {
        pageSize: 15,
        pageNumber: 1,
      },
      (resp) => {
        const modifiedPermissions = resp.data
          .filter(
            (p) => p.permissioN_GROUP === 'Geography' && p.permissioN_ALLOWED,
          )
          .map((d) => d.permissioN_NAME)
        this.setState({ permissions: modifiedPermissions })
      },
    )
  }

  SelectProvinces = (Callback) => {
    this.setState({ ProvinceLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_Province,
      {},
      (data) => {
        this.setState({
          ProvinceLoader: false,
          Provincelist: data.data,
        })
        Callback()
      },
      (error) => {
        this.setState({ ProvinceLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  handleTableChange = (
    type,
    { page, sizePerPage, filters, sortField, sortOrder, cellEdit },
  ) => {
    if (type === 'sort') {
      let tempFieldorderLabel = sortField + 'sortOrder'
      let tempFieldorder =
        this.state[tempFieldorderLabel] === ''
          ? sortOrder
          : this.state[tempFieldorderLabel] === 'asc'
          ? 'desc'
          : 'asc'
      this.setState(
        {
          sortField,
          [tempFieldorderLabel]: tempFieldorder,
        },
        () => {
          this.PopulateTable()
        },
      )
      return
      // let result = this.state.data
      // // Handle column sort
      // if (sortOrder === 'asc') {
      //     result = result.sort((a, b) => {
      //     if (a[sortField] > b[sortField]) {
      //         return 1;
      //     } else if (b[sortField] > a[sortField]) {
      //         return -1;
      //     }
      //     return 0;
      //     });
      // } else {
      //     result = result.sort((a, b) => {
      //     if (a[sortField] > b[sortField]) {
      //         return -1;
      //     } else if (b[sortField] > a[sortField]) {
      //         return 1;
      //     }
      //     return 0;
      //     });
      // }
      // return
    }
    this.setState(
      {
        page,
        sizePerPage,
      },
      () => {
        this.PopulateTable()
      },
    )
  }

  ExportData = (size) => {
    $('#FormSearchBtn').prop('disabled', true)
    this.setState({ loading: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_District,
      {
        pageSize: size,
        pageNumber: 1,
      },
      (resp) => {
        $('#FormSearchBtn').prop('disabled', false)
        if (resp.data.length > 0) {
          // Map
          var ProcessedProvince = Common.ProcessDataInArray(
            this.state.Provincelist,
            'id',
          )
          for (var i in resp.data) {
            resp.data[i].provinceName =
              resp.data[i].provinceId == null
                ? ''
                : ProcessedProvince[resp.data[i].provinceId].name
          }

          // Sort
          if (this.state[this.state.sortField + 'sortOrder'] === 'asc') {
            resp.data = resp.data.sort((a, b) => {
              if (a[this.state.sortField] > b[this.state.sortField]) {
                return 1
              } else if (b[this.state.sortField] > a[this.state.sortField]) {
                return -1
              }
              return 0
            })
          } else {
            resp.data = resp.data.sort((a, b) => {
              if (a[this.state.sortField] > b[this.state.sortField]) {
                return -1
              } else if (b[this.state.sortField] > a[this.state.sortField]) {
                return 1
              }
              return 0
            })
          }
        }

        // Paginate
        var TotalRecord = resp.totalRecord
        var paginatedData = Common.paginate(
          resp.data,
          this.state.sizePerPage,
          this.state.page,
        )

        this.setState({
          data: resp.data,
          TotalRecord,
          exportLoading: false,
        })
        $('.react-bs-table-csv-btn').click()
        this.PopulateTable()
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }

  PopulateTable = () => {
    $('#FormSearchBtn').prop('disabled', true)
    this.setState({ loading: true })
    var srIdString =
      this.state.SrId.length === 0
        ? ''
        : ',' + Common.convertToCommaString(this.state.SrId, 'id') + ','
    const Parameters = {
      pageSize: this.state.sizePerPage,
      subrecipientId: srIdString,
      name: $('#name').val(),
      pageNumber: this.state.page,
      provinceId: this.state.ProvinceId,
    }
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_District,
      Parameters,
      (resp) => {
        $('#FormSearchBtn').prop('disabled', false)
        if (resp.data.length > 0) {
          // Map
          console.log(resp)
          var ProcessedProvince = Common.ProcessDataInArray(
            this.state.Provincelist,
            'id',
          )
          for (var i in resp.data) {
            resp.data[i].provinceName =
              resp.data[i].provinceId == null
                ? ''
                : ProcessedProvince[resp.data[i].provinceId]?.name
          }

          // Sort
          if (this.state[this.state.sortField + 'sortOrder'] === 'asc') {
            resp.data = resp.data.sort((a, b) => {
              if (a[this.state.sortField] > b[this.state.sortField]) {
                return 1
              } else if (b[this.state.sortField] > a[this.state.sortField]) {
                return -1
              }
              return 0
            })
          } else {
            resp.data = resp.data.sort((a, b) => {
              if (a[this.state.sortField] > b[this.state.sortField]) {
                return -1
              } else if (b[this.state.sortField] > a[this.state.sortField]) {
                return 1
              }
              return 0
            })
          }
        }

        // Paginate
        var TotalRecord = resp.data.length
        var paginatedData = Common.paginate(
          resp.data,
          this.state.sizePerPage,
          this.state.page,
        )

        this.setState({
          data: paginatedData,
          TotalRecord: TotalRecord,
          FilteredData: resp.data,
          loading: false,
        })
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 100)
      },
    )
  }
  onDelete = (id) => {
    this.setState(
      {
        alertModalData: {
          title: 'Delete District',
          message: 'Are you sure you want to delete this record.',
          First_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
            this.DeleteRecord(id)
          },
          Second_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
          },
          type: 1,
        },
      },
      () => {
        $('#Show_ArletModal').click()
      },
    )
  }
  DeleteRecord = (id) => {
    this.props.ShowLoader({ Isloading: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.Delete_District,
      { id: id },
      (Result) => {
        if (Result.status == true) {
          SyncConfig(
            () => {
              this.PopulateTable()
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({ Type: 1, Msg: 'Deleted Successfully.' })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
            () => {
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({
                Type: 0,
                Msg: 'Error in sync, please reload the page',
              })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
          )
        } else {
          this.props.ShowLoader({ Isloading: false })
          this.props.ShowAlert({ Type: 0, Msg: Result.message })
          setTimeout(function () {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wronge, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(District_List)
